import {
  useWSModal,
  WSActions,
  WSAlert,
  WSElement
} from "@wingspanhq/fe-component-library";
import { IEngagement } from "@wingspanhq/payments/dist/interfaces";
import React from "react";
import { ActionEngagementDetails } from "../components/ActionEngagementDetails";

export interface DeleteNotAllowedModalProps {
  engagement: IEngagement;
  onClose: () => void;
}

export const DeleteNotAllowedModal: React.FC<DeleteNotAllowedModalProps> = ({
  engagement,
  onClose
}) => {
  return (
    <>
      <ActionEngagementDetails engagement={engagement} />

      <WSAlert
        my="2XL"
        theme="warning"
        icon="alert"
        size="M"
        title="Engagement type cannot be deleted when:"
      >
        <WSElement as="ul" ml="L">
          <li>Active contractor engagements exist.</li>
          <li>Historical payment data is linked to this engagement type.</li>
        </WSElement>
        If this engagement type is no longer used, it can be archived instead.
      </WSAlert>

      <WSActions
        alignment="fill"
        buttons={[
          {
            label: "Done",
            onClick: onClose,
            kind: "Secondary"
          }
        ]}
      />
    </>
  );
};

export const useDeleteNotAllowedModal = () => {
  return useWSModal(DeleteNotAllowedModal, {
    title: "Delete engagement type",
    size: "M"
  });
};
